import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectCategory = (state: RootState) => state.manufacturer;

const selectManufacturers = createSelector(
  selectCategory,
  (state) => state.manufacturers
);

const selectManufacturersOnFilter = createSelector(
  selectCategory,
  (state) => state.manufacturersOnFilter
);

const selectManufacturerMeta = createSelector(
  selectCategory,
  (state) => state.meta
);

// Selectors for the Manufacturer Details
const selectManufacturerDetails = createSelector(
  selectCategory,
  (state) => state.manufacturerDetails
);

export const selectors = {
  selectManufacturers,
  selectManufacturersOnFilter,
  selectManufacturerMeta,

  // Manufacturer Details Selectors
  selectManufacturerDetails
};
